import { useCallback, useEffect } from 'react';

import { Segment } from '../../../services/analytics-services/segment';
import { ShippyEvents } from '../../../tracking/tracking-constants';
import { useIsRehydrated } from './rehydration-context';

type UseHandlerTrackingOptions = {
  capabilityId: string;
  conversationId: string;
  turnNumber: number;
  parameters: Record<string, unknown>;
  isValid: boolean;
};

export const useHandlerTracking = ({ capabilityId, conversationId, turnNumber, parameters, isValid }: UseHandlerTrackingOptions) => {
  const isRehydrated = useIsRehydrated();

  useEffect(() => {
    if (isRehydrated) return;
    if (isValid) {
      Segment.trackEvent(ShippyEvents.HANDLER_SHOWN, {
        capabilityId,
        conversationId,
        turnNumber,
        capabilityParameters: parameters,
      });
    }
  }, []); // oxlint-disable-line react-hooks/exhaustive-deps -- fire once on mount

  const trackAction = useCallback(() => {
    Segment.trackEvent(ShippyEvents.CAPABILITY_ACTION_CLICKED, {
      capabilityId,
      conversationId,
      turnNumber,
      capabilityParameters: parameters,
    });
  }, [capabilityId, conversationId, turnNumber, parameters]);

  return { trackAction };
};
